import * as commentDirectorTypes from './commentDirectorTypes'

const useCommentDirector = (props: commentDirectorTypes.UseCommentDirectorType) => {
    const { callbackFunction } = props
    const handleChangTextField = (val: string, index: number) => {
        if (callbackFunction) {
            callbackFunction(val, index)
        }
    }
    return {
        onChangTextField: handleChangTextField,
    }
}

export default useCommentDirector
